import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'

import DocThumbnail from './DocThumbnail.js'

import docLoader from '../../docLoader.js'

import './Doc.css';

class Doc extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);
  }

  render(){
    const { dispatch, patternManager } = this.props; 
    const state = this.state;

    const d = this.props.doc;

    return <div className="doc-new">
      <p className="doc-category-label">
        <Link to={"/docs/category/" + d.category.slug}>{d.category.name}</Link>
      </p>
      <h1 className="doc-title">{d.title}</h1>
      <hr/>
      {d.content(this.props, docLoader)}
      
      <div className="doc-tag-wrapper">
        {
          d.tags.map((tag,i)=>{
            return <Link to={"/docs/tag/" + tag} key={i} className="doc-tag">{tag}</Link>;
          })
        }
      </div>
      <hr className="hr-mega-pad"/>
      <h4 className="text-center">Looking for more?</h4>
      <p className="lead text-center">Here are a few docs you might find interesting:</p>
      <div className="row row-eq-height">
        {
          docLoader.list.filter(dd => dd.slug != d.slug).slice(0,3).map((dd, j)=> {
            return <div className="col-md-4" key={j}> 
              <DocThumbnail doc={dd}/> 
            </div>
          })
        }
      </div>
    </div>
  }
}
const mapStateToProps = (state) => {
  const { patternManager } = state;

  return {
    patternManager
  }
}

export default connect(mapStateToProps)(Doc);



// WEBPACK FOOTER //
// ./src/components/Doc/Doc.js